






















































import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { CreateEnterpriseUser, Cancellation, GetenterprisePage } from '../../../api/enterprise/index';
import EditPwd from '../../../components/edit-password.vue';

const validatePhone = (rule: any, value: string, callback: any) => {
  if (value.length != 11) {
    callback(new Error('请输入正确的手机号'));
  } else {
    callback();
  }
};
@Component({
  name: 'EnterpriseUser',
  components: { EditPwd },
})
export default class EnterpriseSetting extends Vue {
  loading = false;
  tableData = [];
  pageNum = 1;
  pageSize = 10;
  total = null;
  addFormVisable = false;
  addForm = {
    nickname: '',
    mobile: '',
    password: '',
    department: '',
  };

  addFormRules = {
    nickname: [
      {
        required: true,
        message: '请输入姓名',
        trigger: 'blur',
      },
    ],
    mobile: [
      {
        required: true,
        message: '请输入手机号',
        trigger: 'blur',
      },
      { validator: validatePhone, trigger: 'blur' },
    ],
    password: [
      {
        required: true,
        message: '请输入密码',
        trigger: 'blur',
      },
    ],
  };
  async mounted() {
    this.getList();
  }

  handleCreate() {
    this.addForm = {
      nickname: '',
      mobile: '',
      password: '',
      department: '',
    };
    this.addFormVisable = true;
    (this.$refs['addFormRef'] as any).resetFields();
  }
  async submitForm() {
    (this.$refs['addFormRef'] as any).validate().then((res: any) => {
      if (res) {
        CreateEnterpriseUser(this.addForm).then(() => {
          this.$message.success('添加成功');
          this.addFormVisable = false;
          this.getList();
        });
      }
    });
  }

  async getList() {
    await GetenterprisePage({ pageNum: this.pageNum, pageSize: this.pageSize }).then(res => {
      this.tableData = res.records;
      this.total = res.total;
    });
  }

  /**
   * 重置密码
   */
  handleReset(index: number, item: any) {
    (this.$refs.editPwdRef as any).$show('reset', item.sn);
  }

  /**
   * 删除用户
   */
  handleDelete(index: number, item: any) {
    this.$confirm(`确认注销该用户吗？`, '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    }).then(res => {
      Cancellation({ userSn: item.sn }).then(() => {
        this.$message.success('注销成功');
        this.getList();
      });
    });
  }

  /**
   * 切换分页
   */
  sizeChange(val: number) {
    this.pageSize = val;
    this.pageNum = 1;
    this.getList();
  }
  currentChange(val: number) {
    this.pageNum = val;
    this.getList();
  }
}
